module.exports = __webpack_public_path__ + "static/media/kishoriWebV1.a5b19207.png";